import { message } from 'antd'
import React, { useEffect, useState } from 'react'
import finish from './../../asset/finish.png'
import { redirectURL } from './../../service_psw'

export default function Step5() {
  const [link, setLink] = useState()
  // 倒计时
  let [countDown, setCountDown] = useState(2);
  // 定时器
  let [timer, setTimer] = useState(0);
  // 改变倒计时 countDown 的值
  const handleTimer = () => {
    setCountDown(10);
  };
  // 使用 useEffect 监听 countDown 变化
  useEffect(() => {
    if (countDown > 0) {
      const newTimer = window.setInterval(() => {
        if (countDown < 1) {
          console.log("倒计时结束:", countDown);
          window.clearInterval(newTimer);
        } else {
          setCountDown((countDown -= 1));
        }
      }, 1000);

      setTimer(newTimer);
    }
    if (countDown <= 1 && link) {
      window.location.href = link
    }
  }, [countDown]);

  // 组件销毁清除倒计时
  useEffect(() => {
    return () => window.clearInterval(timer);
  }, [timer]);
  useEffect(() => {
    redirectURL().then(res => {
      if (res.resultCode === 0) {
        setLink(res.data.link);
      } else {
        message.warning(res.errorMsg, [0.5])
      }
    })
  }, [])
  // useEffect(()=>{
  //     if(link){
  //         setTimeout(()=>{
  //             window.location.href = link
  //         },2000)
  //     }
  // },[link])
  return (
    <>
      <img width={120} src={finish}></img>
      <h2>密码修改成功</h2>
      {link ? <h2 style={{ color: 'red' }}>密码找回成功，{countDown}秒后自动跳转到登录页</h2> : null}
      {link ? <h2 style={{ color: 'red' }}>如未跳转，请 <a style={{ cursor: 'pointer', textDecoration: 'underline' }} href={link}>手动跳转</a></h2> : null}
      {link?null:<div style={{fontSize:'24px',color:'red'}}>{window.pointout}</div>}
    </>
  )
}